import { ServiceType } from '../store/interface/enums';
import Works from '../store/works';

export const getServiceName = (service: ServiceType | undefined): string => {
    const work = Works.find((item) => item.value.toLowerCase() === service?.toLowerCase());
    return work?.name || '';
}
